import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/(main)/layout.tsx\",\"import\":\"Sen\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--sen-font-family\",\"display\":\"swap\"}],\"variableName\":\"sen\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common/RenderGA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/FooterNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/GoogleMapsLoader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
